import type { FormInst } from 'naive-ui'
import { validateHandle } from '@/shared/function'

export async function logicFormSubmit<T>(options: {
  loading: Ref<boolean>
  formRef: Ref<FormInst | null>
  fn: () => Promise<T>
  successMsg?: string
  errorTitle?: string
  errorMsg?: string
}): Promise<boolean | T> {
  const {
    loading,
    formRef,
    fn,
    successMsg = '数据修改成功',
    errorTitle = '数据修改失败',
    errorMsg,
  } = options

  const { isOk } = await validateHandle(formRef)
  if (!isOk)
    return false

  try {
    loading.value = true
    const result = await fn()

    loading.value = false
    useMessage.success(successMsg, { closable: true })

    return result ?? true
  }
  catch (error: any) {
    const msg = getErrorMsg(error)
    recordError(error)
    useDialog.error({
      title: errorTitle,
      content: errorMsg ?? msg,
      positiveText: '确定',
      showIcon: false,
    })
    loading.value = false
    return false
  }
}

export async function logicCatchFn(options: {
  successMsg?: string
  errorTitle?: string
  errorMsg?: string
  fn: () => Promise<any>
}) {
  const {
    fn,
    successMsg = '数据修改成功',
    errorTitle = '数据修改失败',
    errorMsg,
  } = options
  try {
    await fn()
    useMessage.success(successMsg)
    return true
  }
  catch (err) {
    const msg = getErrorMsg(err)
    useDialog.error({
      title: errorTitle,
      content: msg || errorMsg,
      positiveText: '确定',
      showIcon: false,
    })
    return false
  }
}
